var React = require('react');

function ProductsIcon29Inline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Obszar_roboczy_44","data-name":"Obszar roboczy 44","transform":"translate(-8.67 -5.24)"},[React.createElement("rect",{"id":"Rectangle_1091","data-name":"Rectangle 1091","width":"12.06","height":"2.25","transform":"translate(14.34 5.24)","key":0}),React.createElement("path",{"id":"Path_363","data-name":"Path 363","d":"M8.67,34.76V9.92H31.33V34.75H8.67Zm2.23-2.23H29.1V12.15H10.9Z","key":1}),React.createElement("path",{"id":"Path_364","data-name":"Path 364","d":"M16.39,28.17l-3.13-7.02h2.45l3.13,7.02Z","key":2}),React.createElement("path",{"id":"Path_365","data-name":"Path 365","d":"M18.84,28.17l5.75-11.66h2.37L21.21,28.17Z","key":3})]));
}

ProductsIcon29Inline.defaultProps = {"width":"22.66","height":"29.52","viewBox":"0 0 22.66 29.52"};

module.exports = ProductsIcon29Inline;

ProductsIcon29Inline.default = ProductsIcon29Inline;
